import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const settingsIndex = lazyWithRetry(() => import("./routes/index"));

const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings",
  component: () =>
    renderProtectedRoute(settingsIndex, { requirePerms: ["settings:read"] }),
});

const settingsSectionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/$section",
  component: () =>
    renderProtectedRoute(settingsIndex, { requirePerms: ["settings:read"] }),
});

export const settingsRouteTree = [settingsRoute, settingsSectionRoute];
